import { Action, ACTION_TYPE, ERROR_CODE } from '@abiglobalhealth/go-types'

import { actionsRequest, handleRequestError } from './utils'

export const sendHealthNavigatorMessage = async <T extends Action<ACTION_TYPE.SEND_HEALTH_NAVIGATOR_MESSAGE>>(
  payload: T['payload'],
  signal?: AbortSignal
): Promise<T['response']> => {
  try {
    const body = await actionsRequest<T>(
      {
        payload,
        type: ACTION_TYPE.SEND_HEALTH_NAVIGATOR_MESSAGE
      },
      signal
    )

    return body.data
  } catch (err) {
    handleRequestError(err, ACTION_TYPE.SEND_HEALTH_NAVIGATOR_MESSAGE, {})
    throw err
  }
}

export const startHealthNavigator = async <T extends Action<ACTION_TYPE.START_HEALTH_NAVIGATOR>>(
  payload: T['payload'],
  signal?: AbortSignal
): Promise<T['response']> => {
  try {
    const body = await actionsRequest<T>(
      {
        payload,
        type: ACTION_TYPE.START_HEALTH_NAVIGATOR
      },
      signal
    )

    return body.data
  } catch (err) {
    handleRequestError(err, ACTION_TYPE.START_HEALTH_NAVIGATOR, {})
    throw err
  }
}

export const finishHealthNavigator = async <T extends Action<ACTION_TYPE.FINISH_HEALTH_NAVIGATOR>>(
  payload: T['payload'],
  signal?: AbortSignal
): Promise<T['response']> => {
  try {
    const body = await actionsRequest<T>(
      {
        payload,
        type: ACTION_TYPE.FINISH_HEALTH_NAVIGATOR
      },
      signal
    )

    return body.data
  } catch (err) {
    handleRequestError(err, ACTION_TYPE.FINISH_HEALTH_NAVIGATOR, {})
    throw err
  }
}

export const healthNavigatorServiceSelected = async <T extends Action<ACTION_TYPE.HEALTH_NAVIGATOR_SERVICE_SELECTED>>(
  payload: T['payload'],
  signal?: AbortSignal
): Promise<T['response']> => {
  try {
    const body = await actionsRequest<T>(
      {
        payload,
        type: ACTION_TYPE.HEALTH_NAVIGATOR_SERVICE_SELECTED
      },
      signal
    )

    return body.data
  } catch (err) {
    handleRequestError(err, ACTION_TYPE.HEALTH_NAVIGATOR_SERVICE_SELECTED, {})
    throw err
  }
}

export const getConversationSummary = async <T extends Action<ACTION_TYPE.GET_CONVERSATION_SUMMARY>>(
  payload: T['payload']
): Promise<T['response']> => {
  const body = await actionsRequest<T>({
    payload,
    type: ACTION_TYPE.GET_CONVERSATION_SUMMARY
  })

  if (!body?.data) throw new Error(ERROR_CODE.NO_DATA)

  return body.data
}

export const storeHealthNavigatorMessageFeedback = async <T extends Action<ACTION_TYPE.STORE_HEALTH_NAVIGATOR_MESSAGE_FEEDBACK>>(
  payload: T['payload'],
  signal?: AbortSignal
): Promise<T['response']> => {
  try {
    const body = await actionsRequest<T>(
      {
        payload,
        type: ACTION_TYPE.STORE_HEALTH_NAVIGATOR_MESSAGE_FEEDBACK
      },
      signal
    )

    return body.data
  } catch (err) {
    handleRequestError(err, ACTION_TYPE.STORE_HEALTH_NAVIGATOR_MESSAGE_FEEDBACK, {})
    throw err
  }
}

export const deleteHealthNavigatorMessageFeedback = async <T extends Action<ACTION_TYPE.DELETE_HEALTH_NAVIGATOR_MESSAGE_FEEDBACK>>(
  payload: T['payload'],
  signal?: AbortSignal
): Promise<T['response']> => {
  try {
    const body = await actionsRequest<T>(
      {
        payload,
        type: ACTION_TYPE.DELETE_HEALTH_NAVIGATOR_MESSAGE_FEEDBACK
      },
      signal
    )

    return body.data
  } catch (err) {
    handleRequestError(err, ACTION_TYPE.DELETE_HEALTH_NAVIGATOR_MESSAGE_FEEDBACK, {})
    throw err
  }
}

export const storeHealthNavigatorSessionFeedback = async <T extends Action<ACTION_TYPE.STORE_HEALTH_NAVIGATOR_CONVERSATION_FEEDBACK>>(
  payload: T['payload'],
  signal?: AbortSignal
): Promise<T['response']> => {
  try {
    const body = await actionsRequest<T>(
      {
        payload,
        type: ACTION_TYPE.STORE_HEALTH_NAVIGATOR_CONVERSATION_FEEDBACK
      },
      signal
    )

    return body.data
  } catch (err) {
    handleRequestError(err, ACTION_TYPE.STORE_HEALTH_NAVIGATOR_CONVERSATION_FEEDBACK, {})
    throw err
  }
}
